"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindowObject = getWindowObject;

var _hasWindow = require("./has-window");

/**
 * Safely gets a property from the window object
 * @param {string} key property on window to retrieve
 */
function getWindowObject(key) {
  return _hasWindow.HAS_WINDOW ? window[key] : null;
}
//# sourceMappingURL=get-window-object.js.map